<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" (click)="guardarTasas()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Tasas {{solicitudTasasEx.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />-->
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <!--<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{solicitudTasasEx.CodigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{solicitudTasasEx.IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudTasasEx.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{solicitudTasasEx.IdEstadoSolicitudExDescripcion}}" />
                <img *ngIf="solicitudTasasEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudTasasEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudTasasEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudTasasEx.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudTasasEx.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudTasasEx.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{solicitudTasasEx.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="solicitudTasasEx.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudTasasEx.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudTasasEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header">
                        <!--<strong>Tasas</strong>-->
                    </div>
                    <div class="card-body-detalle">

                        <div class="row" style="margin-bottom:15px;">

                            <div class="form-group col-md-3">
                                <!-- required-field -->
                                <label class="col-form-label" for="inpTotalTasas">Importe Tasa (€)</label>
                                <input formControlName="TotalTasas" [decimalsOnly]="2" maxlength="15" name="TotalTasas" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('TotalTasas')" id="inpTotalTasas" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('TotalTasas','required')">
                                    El importe de la tasa es obligatorio
                                </div>
                                <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('TotalTasas','pattern')">
                                    Formato incorrecto.
                                </div>

                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaLiquidacion">Fecha Liquidación</label>
                                <p-calendar formControlName="FechaLiquidacion" inputStyleClass="form-control" utc="true" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpNumeroLiquidacion">Nº Liquidación</label>
                                <div class="input-group">
                                    <input formControlName="NumeroLiquidacion" numbersOnly maxlength="13" name="NumeroLiquidacion" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('NumeroLiquidacion')" id="inpDescripcion" type="text" value="">

                                    <span class="input-group-btn">
                                        &nbsp;<button [disabled]="!habilitarGuardar" name="btnAddTasa" class="btn btn-list btn-secondary" type="button" title="Añade una Tasa" (click)="onAddTasa()"><i class="fa fa-plus"></i></button>
                                    </span>
                                </div>
                            </div>

                        </div>

                        <!--GRID-->
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card card-accent-success animated fadeIn">
                                    <a class="card-header-a">
                                        <div class="card-header-buscador">
                                            <i class="fa fa-list"></i> Listado de Tasas
                                        </div>
                                    </a>

                                    <div class="card-body-grid">

                                        <p-table #tableSearch autoLayout="true" [value]="solicitudTasasEx.TTasaExCollection"
                                                 [columns]="colsTasas" sortField="FechaLiquidacion" sortOrder="-1"
                                                 styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                                 [ngClass]="displayGridHidden(solicitudTasasEx.TTasaExCollection)">

                                            <ng-template pTemplate="header" let-columns>
                                                <tr>
                                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                        {{col.header}}
                                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                                    </th>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                                <tr>

                                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                        <span *ngIf="(col.field!=='Link' && col.field!=='FechaLiquidacion' && col.field!=='TotalTasas')">
                                                            {{rowData[col.field]}}
                                                        </span>

                                                        <span *ngIf="(col.field==='FechaLiquidacion')">
                                                            {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                                        </span>

                                                        <span *ngIf="(col.field==='TotalTasas')">
                                                            {{rowData[col.field] | number:'1.2-2':'es'}}
                                                        </span>

                                                        <div *ngIf="col.field==='Link'" class="btn-group">

                                                            <button (click)="onDeleteTasa(rowData)" [disabled]="!habilitarGuardar" type="button"
                                                                    class="btn btn-sm btn-danger">
                                                                <span class="fa fa-remove"></span>
                                                            </button>

                                                        </div>
                                                    </td>
                                                </tr>

                                            </ng-template>
                                        </p-table>
                                        <div *ngIf="numeroTasas === 0" class="empty-grid">
                                            No hay tasas asociadas a la solicitud
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-12">
                <label class="col-form-label" for="inpNumeroLiquidacion">Enlace de interés:  </label>
                <a href="https://sede.administracionespublicas.gob.es/pagina/index/directorio/tasa055" target="_blank">
                    Acceso al pago de Tasa 055
                </a>
            </div>
        </div>
    </div>

</form>
